import { render } from "./VCardBody.vue?vue&type=template&id=17573518"
import script from "./VCardBody.vue?vue&type=script&lang=js"
export * from "./VCardBody.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__